import axios from 'axios';

const getList = (params) => axios.get('/fornecedor/catalogos', {
  params,
});
const get = (id) => axios.get(`/fornecedor/catalogos/${id}`, {});

const save = (catalogo) => {
  if (catalogo.id) {
    return axios.put(`/fornecedor/catalogos/${catalogo.id}`, catalogo);
  }
  return axios.post('/fornecedor/catalogos', catalogo);
};

const remover = (id) => axios.delete(`/fornecedor/catalogos/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
